import React from 'react';
export function FinalCTA() {
  return <section className="py-8 sm:py-20 bg-[#0a1628] border-t border-gray-800 text-center" data-id="element-62">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-63">
        <h2 className="text-xl sm:text-4xl md:text-5xl font-black text-white mb-3 uppercase tracking-tight" data-id="element-64">
          ¿LISTO/A PARA DEJAR DE IMPROVISAR?
        </h2>

        <p className="text-sm sm:text-xl text-gray-300 mb-4 font-medium" data-id="element-65">
          Unite a docentes que ya tienen su año completo de Proyecto
          Organizacional resuelto.
        </p>

        <a href="https://mi-tienda-2-8952.myshopify.com/cart/51602555437376:1" className="inline-flex items-center justify-center bg-[#dc2626] hover:bg-red-700 text-white text-base sm:text-2xl font-bold py-3 sm:py-5 px-6 sm:px-12 rounded-full shadow-[0_0_30px_rgba(220,38,38,0.6)] transition-all transform hover:scale-105 animate-pulse" data-id="element-66">
          👉 QUIERO EMPEZAR AHORA
        </a>
      </div>
    </section>;
}